import script from "./LatexStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./LatexStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./LatexStylePanel.vue?vue&type=style&index=0&id=79d8ab96&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79d8ab96"]])

export default __exports__